export default __webpack_public_path__ + "assets/6fb3e460ab668c8cc461ed724f085520.svg";